import { useState } from "react";
import { Card, Spin } from "antd";
import React from "react";
import { isEmpty } from "lodash";
import styled from "styled-components";
import moment from "moment-timezone";
import { getUser } from "../api/user";

const Scroll = styled.div`
  max-height: 300px;
  overflow-y: scroll;
`;

export type Log = {
  _id: string;
  createdAt: string;
  reason: string;
  note: string;
  adminId?: string;
  adminName?: string;
  previousStatus: string;
  currentStatus: string;
};

function StatusChangeLogsCard({
  logs,
  tmz,
  type,
}: {
  logs: Log[];
  tmz?: string;
  type: "Worker" | "Workplace";
}) {
  return (
    <Card title="Status Logs">
      <ul>
        <Scroll>
          {isEmpty(logs)
            ? `No Logs`
            : logs.map((log) => {
                const dateWithTimezone = log.createdAt
                  ? moment(log.createdAt).tz(tmz).format("YYYY-MM-DD HH:mm a")
                  : "No Created At";

                return (
                  <li style={{ marginBottom: 10 }} key={log._id}>
                    Status changed from <strong>{log.previousStatus}</strong> to{" "}
                    <strong>{log.currentStatus}</strong>
                    <br />
                    <strong>Reason : </strong> {log.reason || "No Reason"}
                    <br />
                    <strong>Note : </strong> {log.note ? log.note : "No Notes"}
                    <br />
                    <strong>Created At ({type}'s timezone) : </strong> {dateWithTimezone}
                    {!isEmpty(log.adminId || log.adminName) && <LogNameBlock log={log} />}
                  </li>
                );
              })}
        </Scroll>
      </ul>
    </Card>
  );
}

function LogNameBlock({ log }: { log: Log }) {
  return (
    <>
      <br />
      {log.adminName && <ShowAdminName adminName={log.adminName} />}
      {!log.adminName && log.adminId && <ShowNameButton userId={log.adminId} />}
    </>
  );
}

function ShowAdminName({ adminName }: { adminName: string }) {
  return (
    <>
      <strong>Changed by:</strong> {adminName}
    </>
  );
}

function ShowNameButton({ userId }: { userId: string }) {
  const [name, setName] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const showName = async (userId) => {
    setIsLoading(true);
    const user = await getUser(userId);
    setName(user.employee ? user.employee.name : user.agent?.name);
    setIsLoading(false);
  };

  return (
    <>
      <strong>Changed by:</strong> {!isEmpty(name) && name}
      {isEmpty(name) && !isLoading && (
        <button
          onClick={() => {
            void showName(userId);
          }}
          disabled={isLoading}
        >
          Show name
        </button>
      )}
      {isLoading && <Spin />}
    </>
  );
}

export { StatusChangeLogsCard };
